var _defs, _rect, _line, _line2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShadcnUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st1 {\n        stroke: #efefefff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 32px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 256,
    height: 256
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 208,
    y1: 128,
    x2: 128,
    y2: 208
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 192,
    y1: 40,
    x2: 40,
    y2: 192
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShadcnUi);
export default __webpack_public_path__ + "static/media/icon-shadcn-ui.ebb37441d4b7af9eb030b256fbcae533.svg";
export { ForwardRef as ReactComponent };